export const copyText = (options = {}) => {
  options = Object.assign({
    root: document.body,
    selectorLiteral: '[data-copy-text]',
    selectorTarget: '[data-copy-target]',
    attributeLiteral: 'data-copy-text',
    attributeTarget: 'data-copy-target',
    attributeMessage: 'data-copy-message'
  }, options);
  let root = options.root;
  if (typeof root === 'string') {
    root = document.querySelector(options.root);
  }
  if (!root) {
    console.warn('Copy text has no valid root.');
    return;
  }
  const displayMessage = element => {
    const message = element.getAttribute(options.attributeMessage);
    if (message) {
      window.modalPrompt.create(message);
    }
  };
  const copyLiterals = Array.from(root.querySelectorAll(options.selectorLiteral));
  const setupCopyLiteral = element => {
    element.addEventListener('click', () => {
      navigator.clipboard.writeText(element.getAttribute(options.attributeLiteral));
      displayMessage(element);
    });
  };
  for (const element of copyLiterals) {
    setupCopyLiteral(element);
  }
  const copyTargets = Array.from(root.querySelectorAll(options.selectorTarget));
  const setupCopyTarget = element => {
    element.addEventListener('click', () => {
      const targetSelector = element.getAttribute(options.attributeTarget);
      let targetElement = root.querySelector(targetSelector);
      if (!targetElement) {
        targetElement = document.querySelector(targetSelector);
        if (!targetElement) {
          return;
        }
      }
      navigator.clipboard.writeText(targetElement.textContent);
      displayMessage(element);
    });
  };
  for (const element of copyTargets) {
    setupCopyTarget(element);
  }
};
export default copyText;